const mobileMQ = window.matchMedia("(max-width: 1024px)");

export class Subnav {
  private element: HTMLElement;
  private toggle: HTMLButtonElement | null;
  private list: HTMLElement | null;
  private innerLinks: NodeListOf<HTMLAnchorElement>;
  private expanded: boolean = false;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;
      this.toggle = this.element.querySelector(".subnav__toggle");
      this.list = this.element.querySelector(".subnav__list");
      if (this.list) {
        this.innerLinks = this.list.querySelectorAll("ul li a");
      }
      this.init();
    }
  }

  private init() {
    this.handleResize();
    this.handleToggleClick();
    this.handleListTransition();
  }

  private handleResize() {
    const resize = () => {
      if (
        mobileMQ.matches ||
        this.element.classList.contains("subnav--always-dropdown")
      ) {
        this.toggle?.setAttribute("aria-expanded", `${this.expanded}`);
        this.list?.setAttribute("aria-hidden", `${!this.expanded}`);
      } else {
        if (this.list) {
          this.list.style.removeProperty("height");
          this.list.setAttribute("aria-hidden", "false");
        }
      }
      this.handleEscKey();
      this.handleTabbingPast();
      this.closeOnOutsideClick();
    };
    mobileMQ.addEventListener("change", resize);
    resize();
  }

  private handleListTransition() {
    this.list?.addEventListener("transitionend", (event) => {
      if (event.propertyName === "height") {
        if (this.list) {
          this.list.style.removeProperty("height");
        }
      }
    });
  }

  private handleToggleClick() {
    this.toggle?.addEventListener("click", () => {
      this.expanded = !this.expanded;
      this.toggleVisibility();
    });
  }

  private toggleVisibility() {
    this.toggle?.setAttribute("aria-expanded", `${this.expanded}`);
    this.list?.setAttribute("aria-hidden", `${!this.expanded}`);
  }

  private handleEscKey() {
    if (
      mobileMQ.matches ||
      this.element.classList.contains("subnav--always-dropdown")
    ) {
      document.addEventListener("keydown", (event) => {
        const key = event.key || event.keyCode;
        if (key === "Escape" || key === "Esc" || key === 27) {
          if (this.list?.getAttribute("aria-hidden") === "false") {
            this.expanded = !this.expanded;
            this.toggleVisibility();
          }
        }
      });
    }
  }

  private handleTabbingPast() {
    const lastLink = this.innerLinks[
      this.innerLinks.length - 1
    ] as HTMLAnchorElement;
    lastLink.addEventListener("keydown", (event) => {
      if (event.key === "Tab" && !event.shiftKey) {
        if (
          mobileMQ.matches ||
          this.element.classList.contains("subnav--always-dropdown")
        ) {
          this.expanded = !this.expanded;
          this.toggleVisibility();
        }
      }
    });
  }

  private closeOnOutsideClick() {
    document.body.addEventListener("click", (event) => {
      const target = event.target as HTMLElement;
      if (
        this.list?.getAttribute("aria-hidden") === "false" &&
        !this.element.contains(target) &&
        (mobileMQ.matches ||
          this.element.classList.contains("subnav--always-dropdown"))
      ) {
        this.expanded = !this.expanded;
        this.toggleVisibility();
      }
    });
  }
}

export default function subnavInit() {
  new Subnav(document.querySelector(".subnav") as HTMLElement);
}
